<template>
  <section
    class="flex justify-between w-full"
    :class="labelTop ? 'flex-col gap-y-4' : null"
  >
    <label for="company" class="w-1/3 text-sm text-gray-400">{{ label }}</label>

    <div
      class="flex flex-wrap items-center px-5 py-2 bg-gray-100 rounded-md"
      style="min-height: 55px"
    >
      <ListMarkedData
        :marked-datas="markedDatas"
        @on-remove-data="onRemoveData"
      />
      <section class="relative">
        <font-awesome-icon
          icon="fa-plus"
          class="mb-2 ml-2 text-gray-400 cursor-pointer"
          @click="showDropdown = !showDropdown"
        />
        <Transition
          enter-active-class="animated fadeInDown"
          leave-active-class="animated fadeOutUp"
        >
          <ListDropdown
            :items="items"
            v-if="showDropdown"
            :query="query"
            @on-search="$emit('on-search', $event)"
            @on-marked-data="onMarkedData"
          />
        </Transition>
      </section>
    </div>
  </section>
</template>

<script>
import ListDropdown from "./ListDropdown.vue";
import ListMarkedData from "./ListMarkedData.vue";
export default {
  name: "ButtonDropdown",
  components: { ListDropdown, ListMarkedData },
  props: {
    label: {
      type: String,
      required: true,
      default: "",
    },
    labelTop: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDropdown: false,
      markedDatas: [],
    };
  },
  methods: {
    onMarkedData(value) {
      const findMarkedData = this.markedDatas.find(
        (data) => data._id === value._id
      );
      if (!findMarkedData) {
        this.markedDatas.push(value);
      }
      this.$emit("on-select-company", value);

      this.$emit("on-get-companies", this.markedDatas);
    },
    onRemoveData(value) {
      const objectWithId = this.markedDatas.findIndex(
        (markedData) => markedData._id === value._id
      );
      if (objectWithId > -1) {
        this.markedDatas.splice(objectWithId, 1);
      }
      this.$emit("on-remove-bank", value);
      this.$emit("on-get-companies", this.markedDatas);
    },
  },
};
</script>
